const state = {
  property : { createdAt : { order : 'desc' } },
  request  : { createdAt : { order : 'desc' } }
};

const getters = {
  propertySort : state => state.property,
  requestSort  : state => state.request
};

const mutations = {
  SET_SORT : (state, { model, sort }) => {

    state[model] = sort;
  }
};

const actions = {
  updateElasticSort({ commit }, { model, sort }) {

    commit('SET_SORT', { model, sort });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
